// @ts-nocheck
// NOTE: We do not have a .d.ts dec file for global types to declare a .webp module.
// TS is disabled on ONLY this entire file (index.ts)

import civilGridDark from './civilGridDark.png';
import civilGridLight from './civilGridLight.png';
import dark from './dark.webp';
import light from './light.webp';
import outdoors from './outdoors.webp';
import satellite from './satellite.webp';
import satelliteEsri from './satellite-esri.webp';
import satelliteGoogle from './satellite-google.webp';
import streets from './streets.webp';

export default {
  streets,
  outdoors,
  light,
  dark,
  satellite,
  satelliteGoogle,
  satelliteEsri,
  civilGridDark,
  civilGridLight,
};
